import React from 'react';
import { Container } from 'semantic-ui-react';

const SuperTemplateBreadcrumbs = (props) => {
  const { breadcrumbs } = props;
  return (
    <Container className="super-template-breadcrumbs__ui-container">
      <div className="grid-wrapper">
        <span className="super-template-breadcrumbs__container">
          {breadcrumbs?.grandparent_page ? (
            <span className="super-template-breadcrumbs__link">
              <a href={breadcrumbs?.grandparent_page?.uri}>
                {breadcrumbs?.grandparent_page?.title}
              </a>
            </span>
          ) : null}
          <span className="super-template-breadcrumbs__link">
            <a href={breadcrumbs?.parent_page?.uri}>
              {breadcrumbs?.parent_page?.title}
            </a>
          </span>
          <span className="super-template-breadcrumbs__current-page">
            {breadcrumbs?.page?.title}
          </span>
        </span>
      </div>
    </Container>
  );
};

export default SuperTemplateBreadcrumbs;
